import { CustomFormDto } from "../../../types/generated/models";

export const getFormDateInfo = (form: CustomFormDto): { label: string; date: string } => {
    if (form.isExpired && form.expiryDate) {
        return { label: "Expired", date: new Date(form.expiryDate).toLocaleDateString() };
    } else if (!form.isExpired && form.expiryDate) {
        return { label: "Expires", date: new Date(form.expiryDate).toLocaleDateString() };
    } else if (form.dateCompleted) {
        return { label: "Completed", date: new Date(form.dateCompleted).toLocaleDateString() };
    }
    return null;
};
